import { useEffect, useRef, useState } from 'react'
import fetchAPI from '../../../../lib/utils/fetch-api'
import { ReviewDocument, matchFor } from './result-model'

export const useProductPreselection = (reviewId: string, document: ReviewDocument | undefined, disabled: boolean, onSaved: (document: ReviewDocument) => void) => {
  const attempted = useRef(new Set<string>()), callback = useRef(onSaved)
  const [loading, setLoading] = useState(false)
  callback.current = onSaved
  useEffect(() => {
    if (!document || disabled || document.status === 'confirmed' || document.draft.matching_mode === 'unlinked' || attempted.current.has(document.id)) return
    const missing = document.original.items?.some(source => {
      const draft = document.draft.items.find(item => item.line_number === source.line_number)
      return draft && !draft.checked && !matchFor(source, draft)
    })
    if (!missing) return
    attempted.current.add(document.id)
    let active = true
    setLoading(true)
    fetchAPI(`/api/supply/reviews/${reviewId}/documents/${document.id}/auto-match-products`, {
      method: 'POST', timeoutMs: 90000, body: JSON.stringify({ version: document.version }),
    }).then(result => {
      if (active && result.data?.selected > 0 && result.data.document) callback.current(result.data.document)
    }).catch(() => undefined).finally(() => { if (active) setLoading(false) })
    return () => { active = false; setLoading(false) }
  }, [reviewId, document?.id, document?.version, disabled])
  return loading
}
